<template>
  <div class="app__content section">
    <div class="section__wrapper">
      <div class="section__content">
        <h2 class="">404 - Sorry, there's nothing here</h2>
        <router-link :to="'/'">Go home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '404',
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// 404.vue?7ba2e522